import React from 'react';
import R from 'ramda';

const forExample = {
  seasonName: {
    label: 'Season Name',
    example: 'Peak/High Season',
    shorthand: 'Peak',
  },
  rateSetName: {
    label: 'Rate Set Name',
    example: 'Nightly Midweek',
    shorthand: 'Midweek',
  },
  minMaxStay: {
    label: 'Min/Max Stay',
    example: '2 - 4 Nights',
    shorthand: '2-4Nts',
  },
  stayPay: {
    label: 'Stay X Pay Y',
    example: 'Stay 3 Pay 2',
    shorthand: 'S3P2',
  },
  daysOfWeek: {
    label: 'Days of The Week',
    example: 'Mon - Wed',
    shorthand: 'M-W',
  },
  rateSetCode: {
    label: 'Rate Set / Booking Code',
    example: 'DKFUE23',
    shorthand: 'DKFUE23',
  },
};

const Example = ({ rule, combinable, limit }) => {
  const getShorthand = ({ field }) => R.pathOr('', [field, 'shorthand'], forExample);
  return (
    <div>
      {
        R.call(R.compose(
          R.addIndex(R.map)((ele, index) => (
            <div key={index}>
              <div style={{ width: '50%', display: 'inline-block' }}>{ele.label}:</div>
              <div style={{ marginLeft: '16px', display: 'inline-block' }}>{ele.example}</div>
            </div>
          )),
          R.values
        ), forExample)
      }
      <br/>
      <b style={{ margin: '16px 0px 8px 0px', fontWeight: 'bold' }}>Result: </b>
      {
        R.call(R.compose(
          R.slice(0, limit),
          R.ifElse(
            () => combinable,
              R.reduce((result, ele) => {
                const shorthand = getShorthand(ele);
                if (shorthand) {
                  if (result) return `${result}-${shorthand}`;
                  return shorthand;
                }
                return result;
              }, ''),
            R.compose(getShorthand, R.head)
          ),
          R.filter(R.propEq('checked', true))
        ), rule)
      }
    </div>
  );
};

export default Example;



// WEBPACK FOOTER //
// ./src/app/components/integration/settings/rate-name-text-example.jsx